import {
  ErrorResponseCodeType,
  EndPointsNames,
  ApiCredentialsType,
} from '_core/types';
import { setEntityName } from '_core/util/object';

export const API_DOMAIN: EndPointsNames = 'ApiAccount';
export const ENDPOINT_API_PATH = 'v1/members/memberNumber/recover';
export const ENTITY_NAME = setEntityName(ENDPOINT_API_PATH);
const API_CREDENTIALS_TYPE: ApiCredentialsType = 'TOKEN_CREDENTIALS';
const URL_POSTMAN =
  'https://smiles-sa.postman.co/workspace/1aa3f7db-730f-4a9e-8904-3201cc3d9669/api/09ed6560-aee0-4ca3-9d25-a56e6d367008';

export const CODE_ERRORS: ErrorResponseCodeType[] = [
  {
    code: '1',
    bussinessErrorVariant: 'errorService',
    message:
      'Ocorreu um erro técnico (Erro inesperado, favor contactar a Smiles)',
  },
  {
    code: '3',
    bussinessErrorVariant: 'userNotFound',
    message: 'Usuário não cadastrado',
  },
  {
    code: '4',
    bussinessErrorVariant: 'wrongData',
    message: 'Dados incorretos',
  },
  {
    code: '6',
    bussinessErrorVariant: 'loginInvalid',
    message: 'Documento ou Email inválido',
  },
  {
    code: '204',
    bussinessErrorVariant: 'processFailure',
    message:
      'Não foi possível acessar sua conta. Para maiores informações, entre em contato com a central de atendimento Smiles.',
  },
];

export default {
  API_DOMAIN,
  ENDPOINT_API_PATH,
  API_CREDENTIALS_TYPE,
  URL_POSTMAN,
  CODE_ERRORS,
  ENTITY_NAME,
};
